// extracted by mini-css-extract-plugin
export default {"spinner":"LoadingComponent_spinner__eyQcs","wrapperClass":"LoadingComponent_wrapperClass__FAz43","loadingMessage":"LoadingComponent_loadingMessage__YDAfm"};